import * as v from 'valibot';
import { IdSchema, PhoneNumberSchema } from './common';
import { AdminInfoValueFormSchema } from './admin-info-value';
import { t } from 'i18next';
import { AdminHierarchyRequest } from './admin-hierarchy';

export const AdminFormSchema = v.pipe(v.object({
	username: v.pipe(v.string(), v.nonEmpty(t('Prosím nenechávejte toto pole prázdné.'))),
	firstname: v.pipe(v.string(), v.nonEmpty(t('Prosím nenechávejte toto pole prázdné.'))),
	lastname: v.pipe(v.string(), v.nonEmpty(t('Prosím nenechávejte toto pole prázdné.'))),
	email: v.pipe(v.string(), v.email(t('Prosím zadejte platný e-mail.'))),
	phone: v.nullable(PhoneNumberSchema),
	enabled: v.boolean(),
	roleId: v.pipe(
		v.nullable(IdSchema),
		v.check((value) => value !== null, t('Prosím zvolte roli uživatele.')),
	),
	adminInfoValues: v.objectWithRest({}, AdminInfoValueFormSchema),
	posId: v.array(IdSchema),
	hierarchy: v.array(AdminHierarchyRequest),
}));

export type AdminFormModel = v.InferInput<typeof AdminFormSchema>;
